import React from 'react';

const errorMap = {
    firstName: 'Please enter your first name.',
    surname: 'Please enter your surname.',
    email: 'Please enter your email address.'
};

const ValidationErrors = ({ errors }) => {
    const renderErrors = () => {
        return errors.map(error => {
            const errorMsg = (errorMap[error]) ? errorMap[error] : error;
            return (
                <div>{errorMsg}</div>
            );
        });
    };

    if (errors.length == 0) {
        return null;
    }

    return (
        <div className="checkout-errors" role="alert">
            <h2>Errors</h2>
            { renderErrors() }
        </div>
    );
};

export default ValidationErrors;
